export default __webpack_public_path__ + "images/about/4 Юлия Шалухина дизайнер.jpg";